import { createStore } from 'vuex'
import Api from '@/services/api'

export default createStore({
  state: {
    globalConfig: {
      version: 'standard',
      domain: '',
      presentations: {
        config: {
          options: [],
          script: '',
        },
        leads: [],
        agent: {},
        logoHost: null,
      },
    },
    hidingFieldsConfig: {
      measures: [],
    },
    uploadsConfig: {
      fields: {},
    },
  },
  getters: {
    globalConfig: (state) => state.globalConfig,
    isPrint: (state) => state.globalConfig.version === 'print',
    uploadsFields: (state) => state.uploadsConfig.fields,
    leads: (state) => state.globalConfig.presentations.leads,
    config: (state) => state.globalConfig.presentations.config,
    agent: (state) => state.globalConfig.presentations.agent,
    logoHost: (state) => state.globalConfig.presentations.logoHost,
    agentPhoto: (state) => {
      const { domain } = state.globalConfig
      const { photo_url: photoUrl } = state.globalConfig.presentations.agent

      return photoUrl.includes('Prof') || photoUrl.includes('cdn.winwinapp.ru')
        ? photoUrl
        : `https://${domain}.amocrm.ru${photoUrl}`
    },
    fieldsConfig: (state) => state.hidingFieldsConfig,
    printLink: (state) => {
      const { domain, ids, managerId, pId } = state.globalConfig
      const pIdParam = pId ? `&pId=${pId}` : ''
      return `/${domain}/${managerId}?ids=${ids}${pIdParam}&print=Y`
    },
    customScript: (state) => state.globalConfig.presentations.config.script,
  },
  mutations: {
    SET_GLOBAL_CONFIG(state, globalConfig) {
      state.globalConfig = globalConfig
    },
    SET_HIDING_FIELDS_CONFIG(state, hidingFieldsConfig) {
      state.hidingFieldsConfig = hidingFieldsConfig
    },
    SET_UPLOADS_CONFIG(state, uploadsConfig) {
      state.uploadsConfig = uploadsConfig
    },
    SET_PRESENTATIONS(state, presentations) {
      state.globalConfig.presentations = presentations
    }
  },
  actions: {
    setGlobalConfig({ commit }, globalConfig) {
      commit('SET_GLOBAL_CONFIG', globalConfig)
    },
    async getHidingFieldsConfig({ commit, getters }) {
      const { domain } = getters.globalConfig
      if (!domain) {
        return
      }
      const config = await Api.getHidingFieldsConfig(domain)
      config && commit('SET_HIDING_FIELDS_CONFIG', config)
    },
    async getUploadsConfig({ commit, getters }) {
      const { domain } = getters.globalConfig
      if (!domain) {
        return
      }
      const config = await Api.getUploadsConfig(domain)
      config && commit('SET_UPLOADS_CONFIG', config)
    },
    async setPresentations({ commit, getters }) {
      const { domain, managerId, pId, ids } = getters.globalConfig
      const presenatations = await Api.getPresentation({ domain, managerId, pId, ids })
        .catch((e) => {
          console.error(e)
        })
      if (!presenatations) return
      commit('SET_PRESENTATIONS', presenatations)
    }
  },
})
